module.exports = __webpack_public_path__ + "img/zhonghao.b89ff250.png";